export default {
  orderData: {
    items: [], _links: {}, _meta: {}
  },
  orderList: [],
  orderDetail: {},
  itemDetail: {},
  itemData: {},
  lastOrderRecord: {},
}